module.exports = __webpack_public_path__ + "img/regiter-icon04.6370367f.png";